<template>
  <dialog-modal-fi
    ref="productRetailerDialog"
    class="product-retailer-dialog-fi"
    large-padding
    lazy
  >
    <template #header>
      <h2 class="product-retailer-dialog-fi__headline">
        {{
          $dict.get('online-Shop.Product.Retail-Connect.Select-Retailer') ||
          fields.retailConnectRetailerHeadline?.value
        }}
      </h2>
    </template>

    <template #body>
      <div class="product-retailer-dialog-fi__product-retailers">
        <online-retailers-list-fi
          :retailers="retailers"
          :retailer-facets="retailerFacets"
          variant="product-retailers"
        />
      </div>
    </template>
  </dialog-modal-fi>
</template>

<script setup lang="ts">
import { DialogModalFi } from 'atoms';
import { useTemplateRef } from 'vue';

import OnlineRetailersListFi from '@/components/online-retailers/OnlineRetailersListFi.vue';
import { useFields } from '@/composables/fields';
import type { SingleLineTextField } from '@/sitecoreFieldTypes';

interface FacetElement {
  facetType: string;
  facetName: string;
  name: string;
  count: number;
  selected: boolean;
}

interface Facet {
  multiselect: boolean;
  name: string;
  elements: FacetElement[];
}

interface ProductRetailerFields {
  retailConnectRetailerHeadline?: SingleLineTextField;
}

interface Props {
  retailers?: any[] | null;
  retailerFacets?: Facet[] | null;
}

defineOptions({
  name: 'ProductRetailerDialogFi',
});

withDefaults(defineProps<Props>(), {
  retailers: null,
  retailerFacets: null,
});

const fields = useFields<ProductRetailerFields>();

const productRetailerDialog = useTemplateRef('productRetailerDialog');

const show = () => {
  productRetailerDialog.value?.open();
};

const close = () => {
  productRetailerDialog.value?.close();
};

defineExpose({
  show,
  close,
});
</script>

<style src="./product-retailer-dialog-unscoped-fi" />
